var exports = {
  "e6": "ChannelItem.module__channelItemCore___S3FNOU",
  "$H": "ChannelItem.module__channelItemCoreSelected___S3FNOU",
  "_B": "ChannelItem.module__channelItemCoreUnselected___S3FNOU",
  "Vp": "ChannelItem.module__channelItemCoreHovered___S3FNOU",
  "TV": "ChannelItem.module__typingTooltip___S3FNOU",
  "kp": "ChannelItem.module__channelTypingIndicator___S3FNOU",
  "IM": "ChannelItem.module__typingIndicatorIcon___S3FNOU",
  "U4": "ChannelItem.module__channelItemSelected___S3FNOU",
  "OI": "ChannelItem.module__typingAvatars___S3FNOU",
  "_N": "ChannelItem.module__channelItemIcon___S3FNOU",
  "Jz": "ChannelItem.module__channelItemIconSelected___S3FNOU",
  "Wk": "ChannelItem.module__categoryContainer___S3FNOU",
  "yb": "ChannelItem.module__categoryName___S3FNOU",
  "zc": "ChannelItem.module__iconContainer___S3FNOU",
  "HA": "ChannelItem.module__channelName___S3FNOU",
  "Hq": "ChannelItem.module__actionsContainer___S3FNOU",
  "OO": "ChannelItem.module__channelItemIconUnselected___S3FNOU",
  "Cr": "ChannelItem.module__channelItemIconHighlight___S3FNOU",
  "rC": "ChannelItem.module__channelItemLabel___S3FNOU",
  "gw": "ChannelItem.module__channelItemActions___S3FNOU",
  "kL": "ChannelItem.module__container___S3FNOU",
  "YI": "ChannelItem.module__channelReorderTarget___S3FNOU",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___S3FNOU",
  "XE": "ChannelItem.module__unreadIndicator___S3FNOU",
  "_j": "ChannelItem.module__unreadIndicatorMuted___S3FNOU",
  "fc": "ChannelItem.module__channelItem___S3FNOU",
  "Z$": "ChannelItem.module__channelItemCategory___S3FNOU",
  "RQ": "ChannelItem.module__channelItemRegular___S3FNOU",
  "zx": "ChannelItem.module__channelItemHighlight___S3FNOU",
  "_R": "ChannelItem.module__channelItemMuted___S3FNOU",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___S3FNOU",
  "Fb": "ChannelItem.module__channelItemHoverable___S3FNOU",
  "FN": "ChannelItem.module__channelItemPressed___S3FNOU",
  "Je": "ChannelItem.module__channelItemOver___S3FNOU",
  "X9": "ChannelItem.module__channelItemContextMenu___S3FNOU",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___S3FNOU",
  "GJ": "ChannelItem.module__channelItemDragging___S3FNOU",
  "rO": "ChannelItem.module__channelItemDimmed___S3FNOU",
  "x1": "ChannelItem.module__channelItemMutedState___S3FNOU",
  "Ef": "ChannelItem.module__hoverAffordance___S3FNOU",
  "Mn": "ChannelItem.module__keyboardFocus___S3FNOU",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___S3FNOU",
  "Yq": "ChannelItem.module__categoryContent___S3FNOU",
  "Yl": "ChannelItem.module__categoryIcon___S3FNOU",
  "Sk": "ChannelItem.module__createChannelButton___S3FNOU",
  "$Z": "ChannelItem.module__createChannelIcon___S3FNOU",
  "Ne": "ChannelItem.module__voiceUserCount___S3FNOU",
  "p9": "ChannelItem.module__channelItemVoice___S3FNOU",
  "pL": "ChannelItem.module__contextMenuOpen___S3FNOU",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___S3FNOU",
};

module.exports = exports;
